import { useDeleteQuoteMutation } from "@common/api/quoting/quote"
import { handleError } from "@common/utils"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { DeleteDialog } from "@/components/layout/list-table-menu"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"

export const Route = createFileRoute("/_layout/quotes/delete/$quoteId")({
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "quote:delete", "/"),
  component: DeleteQuoteDialog,
})

function DeleteQuoteDialog(): React.ReactElement {
  const { quoteId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const remove = useDeleteQuoteMutation()

  const close = () => navigate({ to: "/quotes", search: true })

  return (
    <DeleteDialog
      noun="quote"
      pending={remove.isPending}
      onCancel={close}
      onConfirm={() =>
        remove.mutate(
          { quote_id: quoteId },
          {
            onSuccess: () => {
              showToast("Deleted", "Quote deleted.", "success")
              close()
            },
            onError: (error) => handleError(error, showToast),
          },
        )
      }
    />
  )
}
